// Mock data for Svetlana Foundation landing page

export const stats = [
  {
    id: 1,
    value: "47,400+",
    label: "Petition Supporters",
    description: "Verified signatures for Ukrainian Adjustment Act"
  },
  {
    id: 2,
    value: "1000s",
    label: "Families Impacted",
    description: "Working toward economic stability"
  },
  {
    id: 3,
    value: "4",
    label: "Federal Lawmakers",
    description: "3 U.S. Senators + 1 Congressman (Bill Cosponsor)"
  }
];

export const impactStories = [
  {
    id: 1,
    name: "Maria's Success",
    title: "From Temporary Status to Career Growth",
    story: "After two years of uncertainty, Maria now has a stable career path in healthcare. Legal clarity enabled her to pursue professional licensing and plan for her family's future with confidence.",
    image: "https://customer-assets.emergentagent.com/job_advocacy-integration/artifacts/0enp7qlb_IMG_9413.jpeg",
    outcome: "Achieved professional licensing and financial independence"
  },
  {
    id: 2,
    name: "Community Mobilization",
    title: "47,400+ Voices for Change",
    story: "Our grassroots network has mobilized thousands across the nation, holding rallies, engaging with lawmakers, and building a powerful coalition advocating for permanent legal pathways. Our Change.org petition has gathered over 47,400 verified signatures.",
    image: "https://customer-assets.emergentagent.com/job_advocacy-integration/artifacts/j1jdo69m_IMG_9416.jpeg",
    outcome: "47,400+ verified petition signatures for Ukrainian Adjustment Act"
  },
  {
    id: 3,
    name: "Policy Impact",
    title: "Direct Engagement with Federal Lawmakers",
    story: "Through sustained advocacy, we've secured direct meetings with U.S. Senators Chris Murphy, Richard Blumenthal, Ed Markey, and Congressman John Larson. In our meeting with Congressman Larson, he expressed strong support for the Ukrainian Adjustment Act and commitment to helping Ukrainian families secure permanent legal protection.",
    image: "https://customer-assets.emergentagent.com/job_advocacy-integration/artifacts/iu3j7yey_IMG_9410.jpeg",
    outcome: "Met with 4 Federal Lawmakers - Secured Support for Ukrainian Adjustment Act"
  }
];

export const howToHelpOptions = [
  {
    id: 1,
    title: "Book Me to Speak",
    description: "Invite Svetlana to speak at your college, conference, or event. Share powerful stories of advocacy and resilience.",
    action: "speaking",
    icon: "mic"
  },
  {
    id: 2,
    title: "Join Our Network",
    description: "Subscribe to receive updates and advocacy alerts. Be part of our 47,400+ supporter community driving systemic change.",
    action: "signup",
    icon: "users"
  },
  {
    id: 3,
    title: "Support Our Mission",
    description: "Your donation funds grassroots mobilization, policy research, and coalition-building efforts for durable solutions.",
    action: "donate",
    icon: "heart"
  },
  {
    id: 4,
    title: "Partner With Us",
    description: "Organizations, legal services, and employers: collaborate with us to strengthen economic integration pathways.",
    action: "contact",
    icon: "handshake"
  }
];

export const aboutContent = {
  mission: "The Svetlana Foundation is a U.S.-based 501(c)(3) nonprofit advancing permanent legal protection and long-term stability for displaced Ukrainian families.",
  tagline: "Temporary status should not mean permanent uncertainty.",
  problem: "Millions of displaced individuals face long-term economic instability due to the absence of durable legal pathways. Temporary protections provide safety but not permanence, limiting workforce participation, access to credit, housing stability, and upward mobility.",
  solution: "We address this through grassroots mobilization, policy engagement with lawmakers, and building advocacy infrastructure that advances sustainable legal pathways. Our focus is on structural change—converting temporary humanitarian response into long-term economic inclusion.",
  approach: [
    {
      title: "Grassroots Mobilization",
      description: "Built 47,400+ supporter network with verified petition signatures"
    },
    {
      title: "Federal Policy Advocacy",
      description: "Direct meetings with 3 U.S. Senators and 1 Congressman (Bill Cosponsor)"
    },
    {
      title: "Economic Integration",
      description: "Connecting families with legal resources and employer sponsorships"
    }
  ]
};

import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Real API function for email signup
export const signupNewsletter = async (email, name) => {
  try {
    const response = await axios.post(`${API}/newsletter/subscribe`, {
      email,
      name
    });
    return response.data;
  } catch (error) {
    console.error('Newsletter signup error:', error);
    throw error;
  }
};

// Real API function for contact form
export const submitContactForm = async (formData) => {
  try {
    const response = await axios.post(`${API}/contact/submit`, formData);
    return response.data;
  } catch (error) {
    console.error('Contact form error:', error);
    throw error;
  }
};
